import React from 'react';
import { motion } from 'framer-motion';

const LiveBadge = ({ size = 'sm' }) => {
  const sizeClasses = {
    xs: 'text-[8px] px-1 py-0.5',
    sm: 'text-[10px] px-1.5 py-0.5',
    md: 'text-xs px-2 py-1',
    lg: 'text-sm px-3 py-1'
  };

  return (
    <motion.div
      initial={{ scale: 0.8 }}
      animate={{ scale: 1 }}
      className={`bg-gradient-to-r from-pink-500 to-red-500 text-white font-bold rounded ${sizeClasses[size]} flex items-center space-x-1`}
    >
      <motion.div
        animate={{ opacity: [1, 0.5, 1] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className="w-1.5 h-1.5 bg-white rounded-full"
      />
      <span>LIVE</span>
    </motion.div>
  );
};

export default LiveBadge;
